export enum Experiment {
  EnableCSSOptimization = 'specs.myAccount.EnableCSSOptimization',
  EnableMyAccountMiddleware = 'specs.myAccount.EnableMyAccountMiddleware',
  EnablePhoneNumberValidation = 'specs.myAccount.EnablePhoneNumberValidation',
}
